// src/components/layouts/Layout.js
import { useContext } from "react";
import { useLocation, Outlet } from "react-router-dom";
import styled from "styled-components";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import SidebarToggle from "./SidebarToggle";
import Footer from "./Footer";
import { AuthContext } from "../../context/AuthContext";

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const MainContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  transition: all 0.3s ease;
  overflow-y: auto;
`;

const Content = styled.div`
  flex: 1;
  background-color: ${(props) => props.theme.background};
  color: ${(props) => props.theme.text};
  overflow: auto;
  transition: margin-right 0.3s ease;
`;

export default function Layout({
  theme,
  collapsed,
  toggleSidebar,
  onThemeToggle,
}) {
  const location = useLocation();

  const { user } = useContext(AuthContext);

  // Solo mostrar Sidebar en la página principal
  const showSidebar = location.pathname === "/";

  return (
    <LayoutContainer>
      <Navbar
        theme={theme}
        userName={user?.nombre}
        toggleSidebar={toggleSidebar}
        onThemeToggle={onThemeToggle}
      />

      <MainContainer>
        <Content theme={theme}>
          {/* Aquí se renderizan las rutas hijas */}
          <Outlet />
        </Content>

        {showSidebar && <Sidebar collapsed={collapsed} />}
        {showSidebar && (
          <SidebarToggle
            collapsed={collapsed}
            setCollapsed={toggleSidebar}
          />
        )}
      </MainContainer>

      <Footer theme={theme} />
    </LayoutContainer>
  );
}
